export enum LiteratureLabelCollection {
  topForm = 'Top Forms',
  itemDetail = 'Literature Item Detail',
  accountConfig = 'accountConfig',
}
/**
 * Utility class for Literature labels
 */
export class LiteratureLabels {
  private static labelCollections = new Map();
  public static getLabels(collection: any) {
    return this.labelCollections.get(collection);
  }
  public static addLabels(collection: any, labels: any) {
    this.labelCollections.set(collection, labels);
  }
}
